import React, { useState } from 'react';
import { Box, Button, IconButton, Popover, Typography } from '@mui/material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PlatformConfigTab from './PlatformConfig/PlatformConfigTab';
import WhitelistTab from './WhitelistSellers/WhitelistTab';
import '../../common/pillTabs.css';

const INFO_SECTIONS = [
  {
    title: 'Why can I only create?',
    points: [
      'Old configs are kept as a record of what was live before.',
      'To update settings, create a new config with the changes you need, then activate it. The previous one will stay in history.',
    ],
  },
  {
    title: 'Why no delete?',
    points: [
      'Old configs act as a backup you can switch back to if needed.',
      'Only one config is active at a time.',
    ],
  },
];

export default function SettingsPage() {
  const [tab, setTab] = useState(0);
  const [platformTrigger, setPlatformTrigger] = useState(0);
  const [whitelistTrigger, setWhitelistTrigger] = useState(0);
  const [infoAnchor, setInfoAnchor] = useState(null);

  const handleAdd = () => {
    if (tab === 0) setPlatformTrigger((n) => n + 1);
    else setWhitelistTrigger((n) => n + 1);
  };

  return (
    <Box sx={{ px: 3, pt: 1.5, pb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
        <div className="pill-box" style={{ width: '300px' }}>
          <div
            className="pill-slider"
            style={{
              left: `calc(5px + ${tab} * (100% - 10px) / 2)`,
              width: 'calc((100% - 10px) / 2)',
            }}
          />
          <button className={`pill-btn${tab === 0 ? ' active' : ''}`} onClick={() => setTab(0)}>
            Platform Config
          </button>
          <button className={`pill-btn${tab === 1 ? ' active' : ''}`} onClick={() => setTab(1)}>
            Whitelist Sellers
          </button>
        </div>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {tab === 0 && (
            <IconButton
              size="small"
              onClick={(e) => setInfoAnchor(e.currentTarget)}
              sx={{ color: 'rgba(0,0,0,0.35)', '&:hover': { color: '#065F46', bgcolor: 'rgba(6,95,70,0.06)' } }}
            >
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          )}

          <Button
            variant="contained"
            startIcon={<AddOutlinedIcon />}
            onClick={handleAdd}
            sx={{
              bgcolor: '#065F46', fontFamily: 'Heebo', textTransform: 'none',
              borderRadius: '10px', '&:hover': { bgcolor: '#054d38' },
            }}
          >
            {tab === 0 ? 'New Config' : 'Add Seller'}
          </Button>
        </Box>
      </Box>

      {/* Info popover — platform config only */}
      <Popover
        open={Boolean(infoAnchor)}
        anchorEl={infoAnchor}
        onClose={() => setInfoAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { mt: 1, borderRadius: '14px', boxShadow: '0 8px 32px rgba(0,0,0,0.10)', border: '1px solid #f0f0f0', maxWidth: 360, p: 2.5 },
        }}
      >
        {INFO_SECTIONS.map((sec) => (
          <Box key={sec.title} sx={{ mb: 2, '&:last-child': { mb: 0 } }}>
            <Typography sx={{ fontFamily: 'Heebo', fontWeight: 700, fontSize: '12px', color: '#065F46', textTransform: 'uppercase', letterSpacing: 0.7, mb: 1 }}>
              {sec.title}
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              {sec.points.map((p, i) => (
                <Box component="li" key={i}>
                  <Typography sx={{ fontFamily: 'Heebo', fontSize: '12.5px', color: '#362B24', lineHeight: 1.55 }}>
                    {p}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Popover>

      <Box sx={{ display: tab === 0 ? 'block' : 'none' }}>
        <PlatformConfigTab openTrigger={platformTrigger} />
      </Box>
      <Box sx={{ display: tab === 1 ? 'block' : 'none' }}>
        <WhitelistTab openTrigger={whitelistTrigger} />
      </Box>
    </Box>
  );
}
